import React, { useState, useEffect } from 'react';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import DesktopMenu from '../../common/DesktopMenu/index';
import MobileMenu from '../../common/MobileMenu/index';
import useWindowSize from '../../common/windowSize';
import { getCookie } from "../../utils/cookie";
import ApproveUsers from './ApproveUsers';
import AdminGroups from './Groups';
import AdminProducts from './Products';
import AdminUsers from './Users';
import Orders from './Orders';
import { 
  Background, 
} from "../../common/Faq/styles";
import { 
  HelloMessage, 
} from "./styles";

const AdminPanel = () => {
  const [mobileMenu, setMobileMenu] = useState(false)
  const [userName] = useState(getCookie('userName'))
  const [value, setValue] = useState('1');
  const size = useWindowSize();

  const handleChange = async (event, newValue) => {
    setValue(newValue);
  }; 

  useEffect(() => {
    if (size.width < 1200) {
      setMobileMenu(true);
    } else {
      setMobileMenu(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size]);

  return (
      <>
        {mobileMenu ? <MobileMenu single={true}/> : <DesktopMenu single={true}/> }
        <Background marginTop adminPanel>
          <HelloMessage>Welcome {userName ? userName : 'Admin'}</HelloMessage>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChange} aria-label="Admin panel">
                  <Tab label="Groups" value="1" />
                  <Tab label="Products" value="2" />
                  <Tab label="Users" value="3" />
                  <Tab label="Approve New users" value="4" />
                  <Tab label="Orders" value="5" />
                </TabList>
              </Box>
              <AdminGroups />
              <AdminProducts />
              <AdminUsers />
              <ApproveUsers />
              <Orders />
            </TabContext>
          </Box>
        </Background>
      </>
  );
}

export default AdminPanel;
